import { Image, Typography } from "antd";
import favIconUrl from "assets/Images/loadingImage.png";
const NoSelectedUserMessage = () => {
  const { Text } = Typography;
  return (
    <>
      <div className="flex flex-col items-center gap-2">
      <div className="relative w-[70px] h-[70px] bg-[#FFC502] p-4 rounded-full shadow-lg">
        <Image src={favIconUrl} alt="loading" width={"100%"} height={"100%"} />
      </div>
      <div>
        <Text className="!text-black !text-lg">İlan hakkında konuşmaya başlayın</Text>
      </div>
      <div>
        <Text className="!text-sm !text-gray-400">
          İletişim geçerek size en uygun ilanı kısa zamanda bulunuz
        </Text>
      </div>
    </div>
    </>
  );
};

export default NoSelectedUserMessage;
